import { type WebformSubmissionValidationErrorFragment } from '#graphql-operations'

export default function (formErrors: WebformSubmissionValidationErrorFragment[], formKey: string | undefined) {
  return formErrors.some(errorItem => errorItem.element === formKey)
}
